/**
 * @file HeightScaledContent.js
 * @description Component that scales content based only on viewport height while maintaining original width.
 */
import React, { useState, useEffect } from 'react';
import useHeightScaling from '../../hooks/useHeightScaling';
import './HeightScaledContent.scss';

const HeightScaledContent = ({ children, baseHeight = 1080 }) => {
    const { scale, viewportHeight } = useHeightScaling(baseHeight);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobileDevice = () => {
            setIsMobile(window.innerWidth < 768);
        };
        checkMobileDevice();
        window.addEventListener('resize', checkMobileDevice);
        return () => window.removeEventListener('resize', checkMobileDevice);
    }, []);

    // On mobile, use content-fit and allow normal scrolling
    if (isMobile) {
        return (
            <div className="height-scaled-content-wrapper mobile">
                {children}
            </div>
        );
    }

    const scaleStyle = {
        transform: `scale(${scale})`,
        width: '100%',
        height: `${100 / scale}%`,
    };

    return (
        <div
            className="height-scaled-content-wrapper"
            style={{ height: viewportHeight }}
        >
            <div className="height-scaled-content" style={scaleStyle}>
                {children}
            </div>
        </div>
    );
};

export default HeightScaledContent;
